import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Select, Modal } from 'antd';
import api from 'utils/api';

interface IProps {
    onClose: (value: any) => void;
}

interface IData {
    id: number;
    name: string;
    grand_total: number;
    parts: {
        name: string;
    }[];
}

const NewOrder: React.FC<IProps> = props => {
    const [data, setData] = useState<IData[]>([]);
    const [search, setSearch] = useState<string>('');

    const history = useHistory();

    const handleClose = (data?: IData) => {
        if ('onClose' in props) {
            props.onClose(data);
        }
    };

    const fetchResults = (value: string) => {
        if (value.length > 0) {
            setSearch(value);
            api.Quotes.all({
                params: { search: value },
            }).then(data => setData(data.results));
        } else {
            setSearch('');
            setData([]);
        }
    };

    const results = (item: IData) => {
        return (
            <Select.Option key={item.id}>
                <div className="quote-search">
                    <span className="quote-subject">{item.name}</span>
                    <span className="quote-gt">{item.grand_total}</span>
                </div>
                {item.parts.map(value => {
                    if (value.name.includes(search)) {
                        const parts = value.name.split(new RegExp(`(${search})`, 'gi'));
                        return (
                            <span style={{ display: 'block', textIndent: '16px' }}>
                                {parts.map(part =>
                                    part.toLowerCase() === search.toLowerCase() ? <strong>{part}</strong> : part
                                )}
                            </span>
                        );
                    }
                    return null;
                })}
            </Select.Option>
        );
    };

    const selectedRow = (value: any, option: any) => {
        handleClose();
        history.push({ pathname: `/my-account/quotes/${option.key}/order` });
    };

    return (
        <>
            <Modal open={true} title="New Order" onCancel={() => handleClose()} footer={null}>
                <div
                    className="flex flex-row m-auto items-center justify-between mb-5"
                    style={{ border: '1px solid #405764', borderRadius: '4px', maxWidth: '530px', minHeight: '87px' }}
                >
                    <InfoCircleOutlined className="pl-5 text-4xl" style={{ color: '#405764' }} />
                    <span className="text-base mx-3">
                        Search for a Quote Number or a Part Name that you would like to Order:
                    </span>
                </div>
                <p className="text-sm mt-2">Order:</p>
                <Select
                    style={{ width: '100%', border: '1px solid #595959', borderRadius: '4px' }}
                    showSearch
                    onSelect={selectedRow}
                    filterOption={false}
                    onSearch={fetchResults}
                    showArrow={false}
                    notFoundContent={null}
                    optionLabelProp="text"
                    placeholder="PB9001, Rev A"
                >
                    {data.map(results)}
                </Select>

                <Button
                    key="back"
                    size="large"
                    style={{ color: '#D92923', borderColor: '#D92923' }}
                    onClick={() => handleClose()}
                    className="mt-3"
                >
                    Cancel
                </Button>
            </Modal>
        </>
    );
};

export default NewOrder;
